import { columnTranslations } from "../config/columnTranslations";
import styles from "../AdminPanel.module.scss";

const hiddenTables = [
  "auth_token",
  "system_user",
  "price_list",
  "clinic_info",
  "document_file",
];

type Props = {
  tables: string[];
  selectedTable: string | null;
  onSelect: (table: string) => void;
};

function itemClass(active: boolean) {
  return active ? styles.sidebarItemActive : "";
}

export const TableList = ({ tables, selectedTable, onSelect }: Props) => {
  return (
    <>
      <h3>Таблицы</h3>
      <ul>
        <li
          className={itemClass(selectedTable === "__contactsMap")}
          onClick={() => onSelect("__contactsMap")}
        >
          Контакты и описание
        </li>

        <li
          className={itemClass(selectedTable === "__technologies")}
          onClick={() => onSelect("__technologies")}
        >
          Технологии
        </li>

        <li
          className={itemClass(selectedTable === "__priceByDirections")}
          onClick={() => onSelect("__priceByDirections")}
        >
          Цены и подсказки
        </li>

        <li
          className={itemClass(selectedTable === "__employeeWorks")}
          onClick={() => onSelect("__employeeWorks")}
        >
          Выполненные работы
        </li>

        <li
          className={itemClass(selectedTable === "__privacyPolicy")}
          onClick={() => onSelect("__privacyPolicy")}
        >
          Политика конфиденциальности
        </li>

        <li
          className={itemClass(selectedTable === "__legalInfo")}
          onClick={() => onSelect("__legalInfo")}
        >
          Правовая информация
        </li>

        {tables
          .filter((t) => !hiddenTables.includes(t))
          .map((t) => (
            <li
              key={t}
              className={itemClass(selectedTable === t)}
              onClick={() => onSelect(t)}
            >
              {columnTranslations[t] ?? t}
            </li>
          ))}
      </ul>
    </>
  );
};